import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=2304e957"
import script from "./ConfirmAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports